import { useQuery } from '@tanstack/react-query';
import UserCases from '..';
import Loader from '../../../../components/Loader';
import { fetchMyCases } from '../../../../services/caseService';

function MyCases() {
    // ajouter une page de détails des étapes du dossier
    const { isPending: isPendingClientsCases, data: userCasesList } = useQuery({
        queryKey: ['clientCases'],
        queryFn: async () => {
            try {
                const { data } = await fetchMyCases();
                return data || [];
            } catch (error) {
                console.error(error);
            }
            return [];
        },
    });

    if (isPendingClientsCases) {
        return <Loader />;
    }
    return <UserCases userCasesList={userCasesList} />;
}

export default MyCases;
